export default {
    translation: {
        language: 'EN',
        components: {
            footer: {
                helperMessage: "Didn't find what you needed? We recommend these pages:",
                axieZone: '- Axie zone',
                axieInfinity: '- Axie infinity',
                contactUs: '- Contact us',
                privacyAndLegal: '- Privacy & Legal',
                copyright: '© 2020 - 2021 AxieSim. All rights reserved.',
            },
            navbar: {
                companyName: 'Axie Sim',
                tools: 'Tools',
                trackers: 'Trackers',
                login: 'Sign In',
            },
            clipboard: {
                copy: 'Copy to clipboard',
            },
            clipboardSnackbar: {
                copy: 'Copied to clipboard successfully!',
            },
        },
        pages: {
            homepage: {
                title: 'Bring your axies to the next level.',
                seeTools: 'See tools',
                earningsSimulator: {
                    title: 'Earnings simulator',
                    analizeStrategies: '-Do you want to analyze which profit strategies work best in the long term?',
                    trackEarnings:
                        '-Do you want to keep track of your earnings since you started breeding with real time data?',
                    startHereButton: 'Start here',
                },
                scholarshipTracker: {
                    title: 'Scholarship tracker',
                    trackScholars:
                        '-Want to track your scholars spending the least time possible while having personalized graphs for each student with all the information you care about?',
                    checkTracker: 'Then, check our scholarship tracker!',
                    checkButton: 'Check it here!',
                },
            },
            login: {
                title: 'Sign In',
                email: 'Email',
                password: 'Password',
                rememberMe: 'Keep session open',
                register: 'Register',
                forgotPassword: 'Forgot password?',
            },
            register: {
                title: 'Register',
                email: 'Email',
                password: 'Password',
                confirmPassword: 'Confirm password',
                signIn: 'Sign In',
                forgotPassword: 'Forgot password?',
            },
            forgotPassword: {
                title: 'Forgot Password',
                email: 'Email',
                signIn: 'Sign In',
                register: 'Register',
            },
            scholarsTracker: {
                scholarAddDialog: {
                    title: 'Add new scholar',
                    cancel: 'Cancel',
                    confirm: 'Add scholar',
                    scholarName: "Scholar's name",
                    roninAdress: 'Ronin address',
                    managerShare: 'Manager: {{share}}% share',
                    paymentAddress: 'Payment address',
                },
                scholarsPayments: {
                    title: 'Scholars Payments',
                    scholarPaid: '{{scholarName}} has been paid.',
                    payScholar: 'Pay scholar',
                    roninAccount: 'Ronin account',
                    details: 'Details',
                    holdings: 'Holdings',
                    paymentDate: 'Payment date',
                    averageSlp: 'Average SLP',
                    contractMade: 'Contract made',
                    contractAgreed: '{{managerShare}} Manager / {{scholarShare}} Scholar',
                    scholarName: "Scholar's name",
                    payment: 'Payment',
                    paymentAccount: 'Payment account',
                    paymentWarning: '* Payments are for tracking data purposes and not real payments.',
                    slpPerDay: '{{slp}}/day',
                },
                scholarsList: {
                    title: 'Scholars List',
                    editScholar: 'Edit scholar',
                    showInactiveScholars: 'Show inactive scholars',
                    addScholar: 'Add scholar',
                    scholarName: "Scholar's name",
                    roninAccount: 'Ronin Account',
                    averageSlp: 'Average SLP',
                    holdings: 'Holdings',
                    nextClaim: 'Next Claim',
                    percentageAgreed: '% agreed (Man./Sc.)',
                    slpPerDay: '{{slp}}/day',
                    seeDetails: 'See details',
                    removeScholarship: 'Remove scholarship',
                    scholarDeleteDialog: {
                        title: 'Are you sure?',
                        description:
                            'This scholar will not be fully deleted but removed from the scholarship program. His data can be retrieved later. After 12 months the scholar will be fully deleted.',
                        confirm: 'Remove scholarship',
                        cancel: 'Cancel',
                    },
                    successDelete: 'Scholar removed successfully.',
                    successAdd: 'Scholar added successfully.',
                },
                scholarsHomepage: {
                    title: 'Home page',
                    totalRevenue: 'Total revenue',
                    manager: 'Manager',
                    scholar: 'Scholar',
                    revenueMade: 'Revenue made',
                    revenueThisMonth: 'This month',
                    priceList: 'Price list',
                    revenueOverTime: 'Revenue over time',
                    scholarRevenue: 'Scholars revenue ({{coin}})',
                    managerRevenue: 'Manager revenue ({{coin}})',
                    activeScholars: 'Active scholars',
                    newScholars: '+{{scholars}} this month.',
                },
                scholarDetails: {
                    manager: 'Manager',
                    scholar: 'Scholar',
                    totalRevenue: 'Total revenue',
                    arenaRank: 'Arena rank:',
                    slpPerDay: 'SLP per day:',
                    holdings: 'Holdings:',
                    slpClaimed: 'SLP claimed:',
                    nextClaim: 'Next claim:',
                    lastClaim: 'Last claim:',
                    scholarAccount: 'Scholar account:',
                    paymentAccount: 'Payment account:',
                    days: 'Days',
                    revenueOverTime: 'Revenue over time',
                    scholarRevenue: 'Scholar revenue ({{coin}})',
                    managerRevenue: 'Manager revenue ({{coin}})',
                    inventory: 'Inventory',
                    profile: 'Profile',
                },
            },
        },
    },
};
